import MainConfig from "../../../entities/main-config/main-config";

export default {
  mainConfig: new MainConfig(),
  auxiliarValue: 0,
};
